import { Injectable } from '@angular/core';
import { CustomerLabelDetail, CustomerLabelDetailRowData, CustomerLabelHeader, CustomerLabelHeaderRowData } from '../pages/customer-label/bean/customer-label';

@Injectable({
  providedIn: 'root'
})
export class CustomerLabelMapperService {

  constructor() { }

    toCustomerLabelHeaderRowData(header:CustomerLabelHeader):CustomerLabelHeaderRowData | undefined {
      if(header == null ){
        return undefined;
      } else {
        const rowData = new CustomerLabelHeaderRowData();
        rowData.seqNo = 1;
        rowData.externOrderKey = header.externOrderKey;
        rowData.facility = header.facility;
        rowData.deliveryId = header.deliveryId;
        rowData.labelKey = header.labelKey;
        rowData.idFromCu = header.idFromCu;
        rowData.ouser2 = header.ouser2;
        return rowData;
      }

    }
  
    toCustomerLabelDetailRowData(details: CustomerLabelDetail[]): CustomerLabelDetailRowData[] {
      if(details == null || details.length == 0){
        return [];
      } else {
        return details.map((detail, index) => {
          const rowData = new CustomerLabelDetailRowData();
          rowData.seqNo = index + 1;
          rowData.externLineNumber = detail.externLineNumber;
          rowData.buyerPo = detail.buyerPo;
          rowData.soLineNo = detail.soLineNo;
          rowData.sku = detail.sku;
          rowData.altSku = detail.altSku;
          rowData.altSkuDescr = detail.altSkuDescr;
          rowData.altSkuSpecDescr = detail.altSkuSpecDescr;
          rowData.docSku = detail.docSku;
          rowData.externWorkOrder = detail.externWorkOrder;
          rowData.retailSku = detail.retailSku;
          rowData.isCustLabelEditable = detail.isCustLabelEditable;
          rowData.custLabel01 = detail.custLabel01;
          rowData.custLabel02 = detail.custLabel02;
          rowData.custLabel03 = detail.custLabel03;
          rowData.custLabel04 = detail.custLabel04;
          rowData.custLabel05 = detail.custLabel05;
          rowData.glAttribute01 = detail.glAttribute01;
          rowData.glAttribute02 = detail.glAttribute02;
          rowData.glAttribute03 = detail.glAttribute03;
          rowData.glAttribute04 = detail.glAttribute04;
          rowData.glAttribute05 = detail.glAttribute05;
          return rowData;
        });
      }
      }
}
